/* Maison Thaevia — Scroll-reveal observer
   Adds .is-visible to .mt-scroll-reveal elements when they enter
   the viewport. One-shot per element (unobserved after trigger).
   Also re-runs on Shopify theme editor section load/reload. */

(function () {
  const SELECTOR = '.mt-scroll-reveal:not(.is-visible)';
  const ROOT_MARGIN = '0px 0px -80px 0px';

  /* Instant fallback for browsers without IntersectionObserver */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: ROOT_MARGIN, threshold: 0.1 }
  );

  function observe() {
    document.querySelectorAll(SELECTOR).forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Re-observe when Shopify theme editor adds or reloads a section */
  document.addEventListener('shopify:section:load', observe);
})();
